import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import HorseCard from "../components/HorseCard.jsx";

const ForSale = () => {
  const [horses, setHorses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api
      .get("/horses/for-sale")
      .then((r) => {
        if (alive) setHorses(r.data || []);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="for-sale-page">
      <Link
        to="/"
        className="inline-flex items-center gap-1 text-sm text-[#1B3B5A] hover:text-[#B8860B] mb-6 font-semibold"
        data-testid="for-sale-back"
      >
        <ArrowLeft size={16} /> Буцах
      </Link>

      <div className="text-center mb-8">
        <div className="text-xs uppercase tracking-[0.25em] text-[#B8860B] mb-2 font-bold">
          Бүх зар
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#1B3B5A]">
          Манай аж ахуйн зарагдаж буй адуу
        </h1>
        {!loading && (
          <div className="text-sm text-[#5C4F42] mt-2" data-testid="for-sale-count">
            Нийт {horses.length} адуу
          </div>
        )}
      </div>

      {loading ? (
        <div className="text-center py-16 text-[#5C4F42]">Ачааллаж байна...</div>
      ) : horses.length === 0 ? (
        <div className="text-center py-16">
          <div className="text-xl text-[#1B3B5A] font-bold mb-2">Одоогоор зарагдаж буй адуу алга байна</div>
          <p className="text-[#5C4F42]">Дараа дахин шалгаж үзнэ үү.</p>
        </div>
      ) : (
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
          data-testid="for-sale-grid"
        >
          {horses.map((h) => (
            <HorseCard key={h.id} horse={h} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ForSale;
